module.exports = __webpack_public_path__ + "892464918627b41814bc47bba1f0b630.ttf";